import { render, staticRenderFns } from "./MayorRptComponent.vue?vue&type=template&id=1a9b7247&"
import script from "./MayorRptComponent.vue?vue&type=script&lang=js&"
export * from "./MayorRptComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports